<template>
    <div id="menu-upload">
    <h1>{{ $t("mobilityOnDemand.title") }}</h1>
    <br>
       <div class="row">
          <div class="col-lg-1 col-xl-3">
          </div>
                <div class="col-lg-2 col-xl-2">
                  {{ $t("mobilityOnDemand.dates") }}
                </div>
                        <div class="col-lg-3 col-xl-2">
                            <div class="dateInput">
                              <label class="black">{{ $t("mobilityOnDemand.from") }}</label>
                              <br>
                              <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY/MM/DD" value-type="format" format="YYYY/MM/DD" >
                              </date-picker>
                             </div>
                        </div>
                                <div class="col-lg-3 col-xl-2">
                                   <div class="dateInput">
                                      <label class="black">{{ $t("mobilityOnDemand.to") }}</label>
                                      <br>
                                      <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY/MM/DD" value-type="format" format="YYYY/MM/DD">
                                      </date-picker>
                                    </div>
                                </div>
                                        <div class="col-lg-3 col-xl-3">
                                          <button type="button" class="publish-btn" @click="downloadReport">
                                          {{ $t("mobilityOnDemand.dowloadReport") }}
                                          </button>
                                        </div>
       </div>
      <br/>
      <div class="row">
              <div class="col-lg-6 col-xl-6">
                  <h3 class="labelBold">
                    {{ this.$t(`mobilityOnDemand.driversReport.subtitle`) }}
                  </h3>
              </div>
                <div class="col-lg-3 col-xl-3">

                </div>

                      <div class="col-lg-3 col-xl-3">
                          <button id="update" class="publish-btn"  @click="updateTable">
                          {{ $t("mobilityOnDemand.update") }}
                          </button>
                      </div>
                    
      </div>
      <div class="row">
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="driversTable">

         <template #status_change_date="props">{{props.row.status_change_date | formatDateOnly(appLang)}}</template>
         <template #status="props">{{ translateStatus(props.row.status) }}</template>


          <template #actions="props">
            <div class="actionsDrivers">
              <!-- Edit -->
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Edit Driver',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.name,
                    edit: true
                  }
                }"
              >
                <i class="far fa-edit"></i>
              </router-link>

     
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Driver Details',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.name,
                    data: props.row,
                    details: true
                  }
                }"
              >
                <i class="far fa-eye"></i>
              </router-link>

            </div>

          </template>

             <div slot="filter__status_change_date">
                <date-picker  id="status_change_date" name="status_change_date" @change="filterDate(keywordServicesMetadata)"  v-model="keywordServicesMetadata"
                 placeholder="YYYY/MM/DD" valueType="YYYY/MM/DD" >
                </date-picker>
             </div>
              <div slot="filter__status">
              <select class="form-control" id ="status" v-model="selected"  @change="filterStatus(selected)">
              <option v-for="option in options"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{option.name }}
              </option>
            </select>
            </div>
        </v-server-table>

      </div>

      </div>
    </div>

</template>



<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import store from '@/vuex/store';

import Mobility from "@/lib/api/MobilityOnDemand.js";

const api = new Mobility();

export default {
  components: {
    DatePicker,
    store,

  },


  data: function() {
    return {
      selected:"",

    dates:
    {
      from: null,
      to: null,
    },
    keywordServicesMetadata:"",
    SuccessMsg:
    {
        show: false
    },
    fechas:"",
    };
  },
  filters: {

    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }

      return moment(value).format("LLLL");
    },

},
  computed:

   {
      options(){
        return[
      {id:"0",name: this.$t('mobilityOnDemand.choose')} ,
      {id:"1",name: this.$t('mobilityOnDemand.driversReport.onLine')} ,
      {id:"2",name: this.$t('mobilityOnDemand.driversReport.inTravel')},
      {id:"3",name: this.$t('mobilityOnDemand.driversReport.disconnected')}
        ]},


      appLang: function() {
      return this.$store.getters['settings/currentLang'];
    },
  

    driversTable: function() {
      return this.$refs.driversTable;

    },
    table_columns: function() {
      return [

        "name",
        "last_name",
        "mothers_last_name",
        "status",
        "status_change_date"


      ];
    },

    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `mobilityOnDemand.driversReport.tableDriversreport.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },

     table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },

     table_options: function() {
      return {
        columns: this.table_columns,
        options: {

          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,


          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,

          texts: {
            filterBy: "{column}",
            columns: this.$t("mobilityOnDemand.driversReport.tableDriversreport.headings.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page ;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.orderBy = data.orderBy ? data.orderBy : "status";
            queries.orderType = data.ascending ? "asc" : "desc";
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            store.commit('global/SET_RESP', "");
            try {
              const resp =  await api.getDrivers(data);
              this.$store.commit("global/SET_LOADING", false);

              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data:  response.data,
              count: response.total
            };
          },
        }
      };
    }
  },

  beforeMount: async function() {

  },
    created: async function() {

  },
  methods: {

    translateStatus (status) {

      if (status == "En linea"){
      status = this.$t("mobilityOnDemand.driversReport.onLine")
      }
      else if(status == "En viaje"){
       status = this.$t("mobilityOnDemand.driversReport.inTravel")
      }
       else if(status == "Desconectado"){
       status =  this.$t("mobilityOnDemand.driversReport.disconnected")
       }
       else {
        status
      }
        return status
    },

    filterStatus: function( $event)
    {
      let status = ""
      if ($event == 1){
    	status = "En linea"
	    }
      else if($event == 2){
    	status = "En viaje"
	    }
      else if($event == 3){
    	status = "Desconectado"
	    }
    this.driversTable.setFilter({"status":status});
    },

    filterDate: function($event)
    {
    this.driversTable.setFilter({"status_change_date":$event});
    },

    updateTable: function () {

      this.driversTable.refresh();
      store.commit('global/SET_RESP', "");
    },

      downloadReport: async function(event) {
      this.$store.commit("global/SET_LOADING", true);
     
      try {
        if(this.dates.to < this.dates.from || this.dates.to == null|| this.dates.from == null)
        {
           if(this.dates.to < this.dates.from )
           {
              this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("mobilityOnDemand.rango")}`,
                show: true,
                type: "error"
               });
              this.$store.commit("global/SET_LOADING", false);
           }
            else{
                  this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("mobilityOnDemand.vacias")}`,
                  show: true,
                  type: "error"
                });
                  this.$store.commit("global/SET_LOADING", false);
                }
        }
          else
                {
                const getDate = (type = "from") => {
                const time = type === "from" ? "00:00" : "23:59";
                return `${this.dates[type]} ${time}`;
                };
                const params = {

                  startDate: getDate("from"),
                  endDate: getDate("to"),
                };
                const resp = await api.downloadDriversReport(params);
                let anchor = document.createElement("a");
                anchor.href = resp.url;
                anchor.target = "_blank";
                anchor.click();
                 this.$store.commit("global/SET_LOADING", false);
                  this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("mobilityOnDemand.dowloadSuccess")}`,
                  show: true,
                  type: "success"
                });
                 
                }

      } catch (error) {
              this.$store.commit("global/SET_ALERT", {
                  msg: `${error}`,
                  show: true,
                  type: "error"
                });
        
        this.$store.commit("global/SET_LOADING", false);
        
        
      }

    }

  }
};
</script>



<style lang="scss" >

@media (min-width: 576px) {
  .dateInput{
  width: auto;
  height: 30px;
}
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) { 
  .dateInput{
  width: auto;
  height: 30px;
}}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .dateInput{
  width: auto;
  height: 30px;
}}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) { 
  .dateInput{
  width: auto;
  height: 30px;
  
}
}   
   .VueTables thead  { 
      position: sticky;
      top: 0;
      z-index: 10;
      background-color: #ffffff;
  }
    
  .table-responsive { 
      height:600px;
      overflow:scroll;
  }

.VueTables__status_change_date-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
 }
#status_change_date{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}

.VueTables__status-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
 }
#status{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}



#menu-upload {
  background-color: $white;
  padding: 2rem 2rem;
}

.publish-btn {

  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
  
}
.menu-upload  .radios .gruop input {
  width: 5%;
}
.menu-upload  .radios .gruop span {
  margin-left: 0.5rem;
}
.menu-upload  .validity .dates {
  display: flex;
}
.menu-upload  .validity .dates .dateInput {
  display: auto;
  flex-direction: column;
 
}
.marLeft {
  margin-left: 12rem;
}
.actionsDrivers {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actionsDrivers > *, button {
  cursor: pointer;
}
.actionsDrivers > .edit-btn {
  color: #000000;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: #000000;
  }
}
.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown {
  float: left !important;
}
.VueTables__columns-dropdown > button {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
}
.VueTables .dropdown .dropdown-menu a {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VueTables .dropdown .dropdown-menu a > input {
  margin-right: 0.5rem;
}

</style>


